module.exports = __webpack_public_path__ + "static/media/sotu.32aaac00.webp";